import { render, staticRenderFns } from "./addProgramPage.vue?vue&type=template&id=fef47f4e&"
import script from "./addProgramPage.vue?vue&type=script&lang=js&"
export * from "./addProgramPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports